export const floatNormalize = value =>
  value
    .replace(/[^0-9.,]/g, "") // replace non number chars
    .replace(/,/g, ".")
    .replace(/^([^.]*\.)(.*)$/, (a, b, c) => b + c.replace(/\./g, "")); // remove dots except first one
